import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './NotificationPopup.css';

const NotificationPopup = () => {
    const [showPopup, setShowPopup] = useState(false);
    const popupRef = useRef(null); 
    const navigate = useNavigate();

    const handleClickOutside = (e) => {
        if (
            popupRef.current && 
            !popupRef.current.contains(e.target) 
        ) {
            setShowPopup(false);
        }
    };

    const handleCircleClick = () => {
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    const handlePopupClick = () => {
        navigate('/career-placement-assistance');
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="notification-container">
            <div
                className={`circle-element ${showPopup ? 'show' : ''}`}
                onClick={handleCircleClick} 
            >
                {!showPopup && <span>Career Support</span>}
                {showPopup && (
                    <FontAwesomeIcon
                        icon={faTimes}
                        onClick={handleClosePopup}
                        className="close-icon"
                    />
                )}
            </div>

            {showPopup && (
                <div
                    className={`premium-courses-popup ${showPopup ? 'show' : ''}`}
                    ref={popupRef}
                    onClick={(e) => e.stopPropagation()}
                    onClickCapture={handlePopupClick}
                >
                    <p>Click to explore our premium courses with expert support!</p>
                    <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
                        <li>
                            <FontAwesomeIcon
                                icon={faCheck}
                                style={{ marginRight: '-9px', color: 'var(--nav-buttons-text)' }}
                            />
                            <strong>Career Support</strong>: Expert placement assistance.
                        </li>
                        <li>
                            <FontAwesomeIcon
                                icon={faCheck}
                                style={{ marginRight: '-9px', color: 'var(--nav-buttons-text)' }}
                            />
                            <strong>Skill Enhancement</strong>: Mock interviews and real-world prep.
                        </li>
                        <li>
                            <FontAwesomeIcon
                                icon={faCheck}
                                style={{ marginRight: '-9px', color: 'var(--nav-buttons-text)' }}
                            />
                            <strong>Internship</strong>: 3-month hands-on experience.
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default NotificationPopup;
